import Vue from "vue";
import Router from "vue-router";

import Home from "../views/Home.vue";

// const Home = () => import("../views/Home.vue");
// const Ysts = () => import("../views/Ysts.vue");
// const Qyfz = () => import("../views/Qyfz.vue");
// const Pygn = () => import("../views/Pygn.vue");
// const Dfts = () => import("../views/Dfts.vue");
// const Pyms = () => import("../views/Pyms.vue");
// const Pyzz = () => import("../views/Pyzz.vue");
// const Pyby = () => import("../views/pyby/Pyby.vue");
// const Gczp = () => import("../views/gczp/Gczp.vue");
// const Pyyz = () => import("../views/pyyz/Pyyz.vue");
// const Yjzx = () => import("../views/yjzx/Yjzx.vue");
// const About = () => import("../views/About.vue");

import Ysts from "../views/Ysts.vue";
import Qyfz from "../views/Qyfz.vue";
import Pygn from "../views/Pygn.vue";
import Dfts from "../views/Dfts.vue";
import Pyms from "../views/Pyms.vue";
import Pyzz from "../views/Pyzz.vue";
import Pyby from "../views/pyby/Pyby.vue";
import Gczp from "../views/gczp/Gczp.vue";
import Pyyz from "../views/pyyz/Pyyz.vue";
import Yjzx from "../views/yjzx/Yjzx.vue";
import About from "../views/About.vue";

Vue.use(Router);

const routes = [
  {
    path: "/",
    component: Home
  },
  {
    path: "/ysts",
    name: "ysts",
    component: Ysts
  },
  {
    path: "/pygn",
    name: "pygn",
    component: Pygn
  },
  {
    path: "/dfts",
    name: "dfts",
    component: Dfts
  },
  {
    path: "/qyfz",
    name: "qyfz",
    component: Qyfz
  },
  {
    path: "/pyms",
    name: "pyms",
    component: Pyms
  },
  {
    path: "/pyzz",
    name: "pyzz",
    component: Pyzz
  },
  {
    path: "/pyby",
    name: "pyby",
    component: Pyby
  },
  {
    path: "/gczp",
    name: "gczp",
    component: Gczp
  },
  {
    path: "/pyyz",
    name: "pyyz",
    component: Pyyz
  },
  {
    path: "/yjzx",
    name: "yjzx",
    component: Yjzx
  },
  {
    path: "/about",
    name: "about",
    component: About
  }
];

const router = new Router({
  routes
});

export default router;
